import { fetch } from "./index";

export const getUserDetails = () => fetch(`users/details`);
